module.exports = __webpack_public_path__ + "img/Kochen.5b0c31d4.png";